"use client";
/**
 * validate authentication with correct url.
 */

import { memo, useMemo } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "@/context/authcontext";

interface Props {
    children: React.ReactNode;
    redirectPreLogin: string;
    redirectPostLogin: string;
}

const ReadonlyAuthRedirect = ({ children, redirectPreLogin, redirectPostLogin }: Props) => {
    const router = useRouter();
    const { isAuthenticated } = useAuth();

    const validRoute = useMemo((): string => {
        if (typeof window !== "undefined") {
            if (isAuthenticated) {
                if (window.location.href.includes(`${redirectPreLogin}`)) {
                    return redirectPostLogin!;
                }
            } else {
                if (window.location.href.includes(`${redirectPostLogin}`)) {
                    return redirectPreLogin!;
                }
            }
        }
        return "";
    }, [isAuthenticated, redirectPreLogin, redirectPostLogin]);

    if (validRoute) {
        router.replace(String(validRoute));
    }

    return <>{!validRoute && children}</>;
};

export default memo(ReadonlyAuthRedirect);
